(ns cljsjs.device
  (:require ["current-device" :as device]))

(js/goog.exportSymbol "device" device)
